module.exports = __webpack_public_path__ + "static/media/wine-flight.89ba3837.jpg";